import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import MenuItem from '@material-ui/core/MenuItem';
import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import parse from 'autosuggest-highlight/parse';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { buscarCNPJ } from 'services/simulador';
import { capitalizeString, CNPJMask } from 'services/utils';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  container: {
    flexGrow: 1,
    position: 'relative',
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    left: 0,
    marginTop: theme.spacing.unit,
    right: 0,
    zIndex: 1,
  },
  suggestion: {
    display: 'block',
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: "0",
      height: "1px",
      right: "15px",
      width: "calc(100% - 30px)",
      backgroundColor: "hsla(0, 3%, 20%, 0.3)",
    },
    "&:last-child": {
      "&:after": {
        content: "none",
      },
    },
  },
  suggestionsList: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
  },
});

class AutosuggestCNPJAsync extends Component {
  state = {
    suggestions: [],
    value: this.props.defaultValue,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.defaultValue !== this.props.defaultValue && this.props.defaultValue !== '') {
      this.setState({ value: this.props.defaultValue });
    }
  }

  getSuggestionValue(suggestion) {
    return suggestion.name;
  }

  // Método chamado quando tem um onChange no input.
  handleSuggestionsFetchRequested = ({ value }) => {
    if (value.length >= 5) {
      this.loadSuggestions(value);
    }
  };

  handleSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] });
  };

  handleChange = (event, { newValue }) => {
    this.setState({ value: newValue });
  };

  loadSuggestions(value) {
    const onlyNumbers = value.replace(/\D/g, '');
    buscarCNPJ(onlyNumbers).then(res => {
      const hasData = res.data && res.data.length !== 0;

      if (hasData) {
        this.setState({ suggestions: res.data });
      } else {
        this.setState({ suggestions: [{
          name: "Buscar no Mercado Cativo",
          cnpj: value,
          id: "CATIVO",
        }] });
      }
    });
  }

  renderInput(inputProps) {
    const { classes, ref, ...other } = inputProps;
    return (
      <TextField
        fullWidth
        InputProps={{
          inputRef: ref,
          classes: {
            input: classes.input,
          },
          ...other,
        }}
      />
    );
  }

  renderSuggestion(suggestion, { query, isHighlighted }) {
    const matches = match(suggestion.name, query);
    const parts = parse(suggestion.name, matches);
    const formattedCNPJ = CNPJMask(suggestion.cnpj);
    const subtext = `${formattedCNPJ} ${suggestion.city ? capitalizeString(suggestion.city) : ""} ${suggestion.stateCode ? "- " + suggestion.stateCode : ""}`;

    return (
      <div>
        <MenuItem component="div" selected={isHighlighted}>
          <div>
            {parts.map((part, index) => {
              return part.highlight ? (
                <span key={String(index)} style={{ fontWeight: 300 }}>
                  {part.text}
                </span>
              ) : (
                <strong key={String(index)} style={{ fontWeight: 500 }}>
                  {part.text}
                </strong>
              );
            })}
          </div>
        </MenuItem>
        <MenuItem component="div" selected={isHighlighted}>
          <div>{subtext}</div>
        </MenuItem>
      </div>
    );
  }

  renderSuggestionsContainer(options) {
    const { containerProps, children } = options;

    return (
      <Paper {...containerProps} square>
        {children}
      </Paper>
    );
  }

  render() {
    const { classes, onHandleSelected, placeholder } = this.props;
    const { suggestions, value } = this.state;

    return (
      <Autosuggest
        getSuggestionValue={this.getSuggestionValue}
        inputProps={{
          autoFocus: true,
          classes,
          onChange: this.handleChange,
          placeholder,
          value,
        }}
        onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
        onSuggestionSelected={(event, { suggestion }) => onHandleSelected(suggestion)}
        onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
        renderInputComponent={this.renderInput}
        renderSuggestion={this.renderSuggestion}
        renderSuggestionsContainer={this.renderSuggestionsContainer}
        suggestions={suggestions}
        theme={{
          container: classes.container,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion,
        }}
      />
    );
  }
}

AutosuggestCNPJAsync.defaultProps = {
  defaultValue: '',
  placeholder: 'Buscar empresa por Nome ou CNPJ',
};

AutosuggestCNPJAsync.propTypes = {
  classes: PropTypes.object.isRequired,
  defaultValue: PropTypes.string,
  onHandleSelected: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

export default withStyles(styles)(AutosuggestCNPJAsync);



// WEBPACK FOOTER //
// ./src/components/EnergyCompany/Autosuggest/AutosuggestCNPJAsync.js